export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: '.left-arrow-home-banners',
      nextEl: '.right-arrow-home-banners',
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

 
  
  const swiperNewModels = new Swiper ('.swiper-new-model', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    pagination: {
      el: '.swiper-pagination.new-model',
      clickable: true,
    },
    on: {
      slideChange: function () {
        // Função para atualizar as informações do veículo
        updateVehicleInfo();
        updateTabAccordingSlide();
      }
    }
  });

  const swiperNewModelHighlights = new Swiper ('.swiper-new-model-highlights', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.highlight',
      prevEl: '.swiper-button-prev.highlight',
    },
    pagination: {
      el: '.swiper-pagination.highlight',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });


 


  const swiperLocations = new Swiper('.swiper-locations', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.locations',
      prevEl: '.swiper-button-prev.locations',
    },
    pagination: {
      el: '.swiper-pagination.locations',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperPromotion = new Swiper ('.swiper-promotion', {
    slidesPerView: 1,
    watchOverflow: true,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    pagination: {
      el: '.swiper-pagination.promotion',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1500: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    },
  });

  const blogInternalRelatedSwiper = new Swiper('.blog-internal-related-slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    watchOverflow: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.blog-internal',
      prevEl: '.swiper-button-prev.blog-internal',
    },
    pagination: {
      el: '.swiper-pagination.blog-internal',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });


  const swiperUsedModelInternalStamp = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedModelInternalThumbs = new Swiper('.used-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedModelInternalThumbs,
    },
  });

  const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });

  const usedModel = new Swiper('.swiper-used-models', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used-models',
      prevEl: '.swiper-button-prev.used-models',
    },
    pagination: {
      el: '.swiper-pagination.used-models',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });


  const newModelsHighlightsAcessoriesThumbs = new Swiper('.new-model-highlights-acessories-slider-thumbs', {
    slidesPerView: 5,
    loop: true,
    freeMode: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  const newModelsHighlightsAcessories = new Swiper('.new-model-highlights-acessories-slider-content', {
    slidesPerView: 1,
    loop: true,
    clickable: true,
    pagination: {
      el: '.swiper-pagination.highlights-acessories',
      clickable: true,
    },
    on: {
      slideChange: function () {
        updateHighlightAcessoriesInfo();
      }
    },
    thumbs: {
      swiper: newModelsHighlightsAcessoriesThumbs,
    },
  });

//functions to control swiper cars on home
  function updateVehicleInfo() {
    if (swiperNewModels && swiperNewModels instanceof Swiper) {
      swiperNewModels.on('transitionEnd', function() {
        let activeSlide = swiperNewModels.slides[swiperNewModels.activeIndex];
  
        if (activeSlide) {
          const vehicleData = JSON.parse(activeSlide.getAttribute('data-vehicle'));
          document.querySelector('.name-car').innerText = vehicleData.name;
          document.querySelector('.year-car').innerText = vehicleData.year;
          document.querySelector('.price-car').innerText = vehicleData.price;
          vehicleData.price !== '' ? document.querySelector('.price-span').innerText = 'A partir de: ' : document.querySelector('.price-span').innerText = '';
          document.querySelector('.motor').innerText = vehicleData.motor;
          document.querySelector('.potencia').innerText = vehicleData.potencia;
        }
      });
    }
  }

  function updateTabAccordingSlide() {
    if (swiperNewModels && swiperNewModels instanceof Swiper) {
      swiperNewModels.on('transitionEnd', function() {
        const activeIndex = swiperNewModels.activeIndex;
  
        if (swiperNewModels.slides[activeIndex]) {
          const currentSlide = swiperNewModels.slides[activeIndex];
          const vehicleData = JSON.parse(currentSlide.getAttribute('data-vehicle'));
          const categoryId = vehicleData['category-id'];
  
          const tabs = document.querySelectorAll('.tabs-style-home');
          tabs.forEach((tab) => tab.classList.remove('active'));
  
          const activeTab = document.querySelector(`.tabs-style-home[data-category="${categoryId}"]`);
  
          if (activeTab) {
            activeTab.classList.add('active');
          }
        }
      });
    }
  }

  function changeSlideByTab(categoryId) {
    // Encontra todos os slides com a categoria correspondente
    const slides = Array.from(swiperNewModels.slides);
    const targetSlides = slides.filter(
      (slide) => JSON.parse(slide.getAttribute('data-vehicle'))['category-id'] === categoryId
    );
  
    // Se encontrou slides com a categoria correspondente, muda para o slide apropriado
    if (targetSlides.length > 0) {
      let targetSlideIndex;
      
      if (targetSlides.length > 1) {
        // Se houver mais de um slide, muda para o segundo slide (índice 1)
        targetSlideIndex = slides.indexOf(targetSlides[1]);
      } else {
        // Se houver apenas um slide, muda para o primeiro slide
        targetSlideIndex = slides.indexOf(targetSlides[0]);
      }
  
      swiperNewModels.slideTo(targetSlideIndex);
    }
  }
  
  const tabs = document.querySelectorAll('.tabs-style-home');
  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const categoryId = this.getAttribute('data-category');
      changeSlideByTab(categoryId);
    });
  });

//function to control swiper highlights acessories
function updateHighlightAcessoriesInfo(){
  if (newModelsHighlightsAcessories && newModelsHighlightsAcessories instanceof Swiper) {
      let activeSlide = newModelsHighlightsAcessories.slides[newModelsHighlightsAcessories.activeIndex];

      if (activeSlide) {
        const highlightData = JSON.parse(activeSlide.getAttribute('data-highlight'));
        document.querySelector('.title-acessories').innerText = highlightData.title;
        document.querySelector('.description-acessories').innerText = highlightData.description;
      }
  }
}

}


